import { noop } from "lodash";
import React from "react";
import { useIntl } from "react-intl";
import { useTheme } from "../../../../config/emotion";
import { ButtonType } from "../../../../globalTypes";
import EwaButton2 from "./EwaButton/EwaButton2";
import { PurposedButtonProps } from "./types";

const AddButtonWithLabel = (
  props: PurposedButtonProps & { label?: string }
) => {
  const { colors } = useTheme();
  const { formatMessage } = useIntl();

  return (
    <EwaButton2
      data-cy="add-button"
      label={props.label || formatMessage({ id: "common.add" })}
      iconName="add"
      buttonColor={colors.save}
      onClick={noop}
      type={ButtonType.Submit}
      {...props}
    />
  );
};

export default AddButtonWithLabel;
